import type { JSX } from 'solid-js';

export const classes = {
  iconLabelContainer: (height: number): JSX.CSSProperties => ({
    position: 'absolute',
    'padding-top': `${height / 5}px`,
    width: '100%',
    'font-size': '12px',
    'justify-content': 'center',
  }),

  BoxStyles: (): JSX.CSSProperties => {
    return {
      'font-size': '0.8rem',
      'text-align': 'left',
      color: 'darkgray',
      'font-weight': 'bold',
      position: 'absolute',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      width: '100%',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      background: 'rgba(242, 246, 248, 0.75)',
    };
  },

  LoadingTextBoxStyles: (): JSX.CSSProperties => ({
    'font-size': '0.8rem',
    color: 'darkgray',
    'font-weight': 'bold',
    'text-align': 'left',
  }),
};
